import config from '../config';
import CtaBand from '../components/CtaBand';
import Footer from '../components/Footer';

// ── HOME PAGE CONTENT ─ edit text here ─────────────────────────

const PILLARS = [
  {
    num: '01',
    icon: (
      <svg className="phi" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <polyline points="13 2 13 9 20 9"/><path d="M20 14v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7"/>
        <line x1="9" y1="14" x2="15" y2="14"/><line x1="9" y1="18" x2="12" y2="18"/>
      </svg>
    ),
    title: 'INSTALLATION',
    desc:  'Komplett montering av kyl- och frysanläggningar, AC-system och storköksutrustning – från planering till driftsättning.',
  },
  {
    num: '02',
    icon: (
      <svg className="phi" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
      </svg>
    ),
    title: 'SERVICE',
    desc:  'Regelbunden service och förebyggande underhåll med fasta avtal – så att utrustningen håller längre och haverier undviks.',
  },
  {
    num: '03',
    icon: (
      <svg className="phi" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        <line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>
      </svg>
    ),
    title: 'FELSÖKNING',
    desc:  'Snabb och träffsäker diagnostik dygnet runt. Vi hittar orsaken – inte bara symtomet – och åtgärdar det direkt på plats.',
  },
  {
    num: '04',
    icon: (
      <svg className="phi" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="9" y="2" width="6" height="4" rx="1"/>
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
        <polyline points="9 12 11 14 15 10"/>
      </svg>
    ),
    title: 'SERVICEAVTAL',
    desc:  'Förebyggande underhåll med fasta avtal – skräddarsydda efter din verksamhet så att du slipper oväntade haverier.',
  },
];

const WHY_POINTS = [
  { num: '01', title: 'Specialiserade kyltekniker',  desc: 'Djup teknisk kompetens ger snabbare diagnos, färre återbesök och längre livslängd på din utrustning.' },
  { num: '02', title: 'Lokal i Göteborg',            desc: 'Snabba utryckningar med god kännedom om stadens restaurang- och livsmedelsbransch.' },
  { num: '03', title: 'Transparenta priser',          desc: 'Tydliga offerter utan dolda avgifter. Du vet exakt vad det kostar innan vi sätter igång.' },
];

const CERTS = ['F-Gas cert.', 'Kylcert. Klass I', 'ISO-utbildad', 'El-säkerhet'];

// ── SNOWFLAKE SVG ──────────────────────────────────────────────
const SnowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <line x1="12" y1="2" x2="12" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/>
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/><line x1="19.07" y1="4.93" x2="4.93" y2="19.07"/>
  </svg>
);

// ══════════════════════════════════════════════════════════════
export default function Home({ navigate }) {
  return (
    <>
      {/* ── HERO ── */}
      <section className="hero">
        <div className="hgrid" />
        <div className="hc">
          <div className="hbadge">❄ {config.tagline}</div>
          <h1>PROFFS PÅ<em>KYLA OCH VÄRME</em></h1>
          <p className="hdesc">{config.description}</p>
          <div style={{ display:'flex', gap:14, flexWrap:'wrap', marginBottom:10 }}>
            <button className="bp" onClick={() => navigate('contact')} style={{ fontSize:'1rem', padding:'16px 36px' }}>
              Begär kostnadsfri offert
            </button>
            <button className="bo" onClick={() => navigate('services')}>Våra tjänster</button>
          </div>
          <p style={{ fontSize:'.75rem', fontFamily:"'DM Mono',monospace", letterSpacing:1, color:'var(--muted)', marginBottom:32 }}>
            SVARAR INOM 24H &nbsp;·&nbsp; JOURLINJE DYGNET RUNT
          </p>
        </div>

        <div className="hv">
          <div className="td">
            <div className="tr" />
            <div className="ff2">
              {[0,1,2,3].map(i => <div key={i} className="f"><SnowIcon /></div>)}
            </div>
            <span className="tn"><span className="tu">−</span>18<span className="tu">°</span></span>
            <div className="tl">Optimal frystemperatur</div>
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <div className="stats">
        {config.stats.map(({ number, label }) => (
          <div className="stat" key={label}>
            <div className="sn">{number}</div>
            <div className="sk">{label}</div>
          </div>
        ))}
      </div>

      {/* ── FOUR PILLARS ── */}
      <section className="hsec">
        <div className="sl">Vad vi gör</div>
        <div className="st">FYRA TJÄNSTER, ETT FÖRETAG</div>
        <div className="ss">
          Installation, service, felsökning och serviceavtal – det är vad vi gör.
          Kyla och värme är vår spetskompetens och vi täcker all storköksutrustning.
        </div>

        <div className="ph">
          {PILLARS.map(({ num, icon, title, desc }) => (
            <div className="phc" key={num} onClick={() => navigate('services')}>
              <div className="phn">{num}</div>
              {icon}
              <div className="pht">{title}</div>
              <div className="phd">{desc}</div>
              <div className="phm">→ Läs mer</div>
            </div>
          ))}
        </div>

        {/* Funnel nudge */}
        <div style={{ textAlign:'center', marginTop:32 }}>
          <button className="bp" onClick={() => navigate('contact')} style={{ fontSize:'1rem', padding:'16px 40px' }}>
            Begär kostnadsfri offert
          </button>
          <p style={{ marginTop:12, fontSize:'.8rem', color:'var(--muted)', fontFamily:"'DM Mono',monospace", letterSpacing:1 }}>
            SVARAR INOM 24H &nbsp;·&nbsp; INGEN BINDNINGSTID
          </p>
        </div>
      </section>

      {/* ── WHY BECOOL ── */}
      <section className="why">
        <div className="wg">
          <div>
            <div className="sl">Varför BeCool</div>
            <div className="st">KYLA OCH VÄRME – VÅR SPETSKOMPETENS</div>
            <div className="ss">
              Vi gör installation, service och felsökning på kyl, frys och värmesystem bättre än andra –
              för det är allt vi fokuserar på.
            </div>
            <div className="wl">
              {WHY_POINTS.map(({ num, title, desc }) => (
                <div className="wi" key={num}>
                  <div className="wn">{num}</div>
                  <div>
                    <div className="wt">{title}</div>
                    <div className="wd">{desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="cc">
              <div className="cct">F-GASCERTIFIERAD</div>
              <div className="ccd">
                Alla våra tekniker är certifierade för arbete med köldmedier enligt EU:s F-gasförordning.
                Din anläggning är i säkra händer.
              </div>
              <div className="ccb">
                {CERTS.map(c => <span className="ccbg" key={c}>{c}</span>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA BAND ── */}
      <CtaBand onAction={() => navigate('contact')} />

      <Footer navigate={navigate} />
    </>
  );
}
